/**
 * DatePicker Component
 */

import React from 'react'
import DateRange from './components/DateRange'
import DateSingle from './components/DateSingle'

const DatePicker = (props) => {
  return props.range ? <DateRange {...props} /> : <DateSingle {...props} />
}

export default DatePicker
